export default __webpack_public_path__ + "static/media/web.38dd4046.svg";